$(document).ready(function(){

  // FUNCTIONS
  // ---------

  function showSuccessMsg(response){
    $('form').delay(400).fadeOut();
    $('.form__notifications .success').text(response.customSuccessMessage);
    $('.form__notifications').delay(800).fadeIn();
  }

  function showErrorMsg(response){
    $('.form__notifications .error').text(response.customErrorMessage);
    $('.form__notifications').fadeIn();

    $.each(response.validationErrors, function(key, value) {
      // Display errors
      $('.field--'+key).addClass('error').find('.errors').html('<p>' + value + '</p>').find('p').fadeIn();
      // Update errors
      $('.field--'+key+' input, .field--'+key+' textarea, .field--'+key+' select').on('change',function(){
        $('.field--'+key).removeClass('error').find('.errors p').fadeOut();
      });
    });
  }

  function showErrorGrecaptchaMsg(response){
    $('.form__notifications .error').text(response.customErrorMessage);
    $('.form__notifications').fadeIn();
  }

  function showErrorEmail(){
    $('.form__notifications .error').text('Invalid Email. Please, check your email address and try to submit again.');
    $('.form__notifications').fadeIn();
  }


  // CONTACT FORM
  // ------------

  var grecaptchaForm = $('.grecaptchaForm');
  grecaptchaForm.on('submit', function(e) {
    e.preventDefault();

    var thisForm = $(this);

    // Reset notifications
    $('.form__notifications .error, .form__notifications .success').text('');

    // -- Get recaptcha token --
    grecaptcha.ready(function() {
      grecaptcha.execute('6LccIqsZAAAAAHkfdhbdZlSKyfb_Ch7m7c-_LJhC', {action: 'contact'}).then(function(token) {
        grecaptchaForm.find('input[name=g-recaptcha-response]').val(token);
        
        // -- Vars --
        var data = thisForm.serialize();
        data[csrfTokenName] = csrfTokenValue;
        $.ajax({
          type: 'POST',
          url: '/',
          dataType: 'json',
          data: data,
          beforeSend: function() { 
            // Disable submit button
            thisForm.find('input[type="submit"]').prop('disabled', true);
          },
          success: function(response, statut){
            // console.log('ajax success');
            // console.log(response);
            if (response.success == true) {
              // console.log('response success');

              // -- check if email is valid --
              if ($('form #email').is(':valid')){
                // -- form submit --
                $.ajax({
                  type: 'POST',
                  url: 'actions/formBuilder2/entry/submitEntry',
                  dataType: 'json',
                  data: data,
                  success: function(response, statut){
                    // console.log('response success');
                    // console.log(response);
                    if (response.success == true) {
                      showSuccessMsg(response);
                    } else {
                      showErrorMsg(response);
                    }
                  },
                  error: function(response, statut, error){
                    // console.log('response error');
                    showErrorGrecaptchaMsg(response);
                  }
                });
              } else {
                showErrorEmail();
              }

                 
            } else {
              // console.log('response error');
              showErrorGrecaptchaMsg(response);
            }
          },
          error: function(response, statut, error){
            // console.log('ajax error');
            // console.log(response);
            showErrorGrecaptchaMsg(response);
          },
          complete: function(response, statut){
            // console.log('ajax complete');
            // Enable submit button
            thisForm.find('input[type="submit"]').prop('disabled', false);
          }
        });
           

      });
    });

  });

});




// -- STRIPE --
// -------------
function checkLabelWidth(){
  var el = $('.field');
  $.each(el,function(key, value){
    var labelW = $(value).find('.heading').outerWidth();
    $(value).find('.input input').css({
      'padding-left': labelW + 14
    });
  });
}


$(document).ready(function(){

  // Check label width to change input padding
  checkLabelWidth();

  // Check checkboxes status
  $('.field--amount input.checkbox').on('change', function() {
    $('.field--amount input.checkbox').not(this).prop('checked', false);  
  });


  // Form submission
  var formAjax = $('.form__ajax');

  formAjax.on('submit', function(e) {
    e.preventDefault();
    
    // Variables
    var thisForm = $(this);
    var url = window.location.href;
    var data = $(this).serialize();
    data[csrfTokenName] = csrfTokenValue;

    // Reset notifications
    $('.form__notifications .error, .form__notifications .success').text('');

    // Ajax subission
    $.ajax({
      type: 'post',
      url: url,
      data: data,
      beforeSend: function() { 
        // Disable submit button
        thisForm.find('input[type="submit"]').prop('disabled', true);
      },
      success: function(response, statut){
        // console.log('success');
        // Enable submit button
        thisForm.find('input[type="submit"]').prop('disabled', false);

        if (!response.success) {
          // ERROR

          // Display notifications
          $('.form__notifications .error').text(response.customErrorMessage);
          $('.form__notifications').fadeIn();

          $.each(response.validationErrors, function(key, value) {
            // Display errors
            $('.field--'+key).addClass('error').find('.errors').html('<p>' + value + '</p>').find('p').fadeIn();

            
            // Update errors
            $('.field--'+key+' input, .field--'+key+' textarea, .field--'+key+' select').on('change',function(){
              $('.field--'+key).removeClass('error').find('.errors p').fadeOut();
            });
          });



        } else {
          // SUCCESS
          
          $('.form__ajax').delay(400).fadeOut();

          // Display notifications
          $('.form__notifications .success').text(response.customSuccessMessage);
          $('.form__notifications').delay(800).fadeIn();
        }
      },
      error: function(response, statut, error){
        // console.log('error');
        // console.log(response);
      }
    });

  });

  // # -- Change color of current selected option -- #
  $('select').on('change', function(){
    $('.select .current').css({'color': '#4D4D4D'});
  });

});